// extracted by mini-css-extract-plugin
export default {"chat-container":"MobileChat_chat-container__vaL23","no-chats-msg-container":"MobileChat_no-chats-msg-container__JmG8l","no-chats-msg":"MobileChat_no-chats-msg__7I+Ml"};